module.exports = __webpack_public_path__ + "static/media/card-car-icon.e6852ec5.svg";